<template>
    <div>
        <div class="header-top" id="header-top">
            <div class="top-content">
                <div>
                 <router-link v-if="!logined" to="/login" class="ns-text-color" style="margin-right: 10px;">您好，请登录</router-link>
                    <div v-if="logined" class="member-info userSwitch">
                        <router-link to="/member/index">{{ member.nickname || member.username }}</router-link>
                        <div>
                            <span @click="dialogFormVisible=true">切换账户<i class="el-icon-arrow-down el-icon--right"></i></span>
                            <!-- this.$router.push({ path: "/member/account_list" }) -->
                            <el-dialog title="切换账户" :visible.sync="dialogFormVisible" width="30%">
							<template v-if="multiaccount.length">
								<div v-for="(item, index) in multiaccount" class="dlistuser">
									<span class="swinames">{{ item.nickname }}</span>
									<span>{{ item.mobile }}</span>
									<el-button v-if="item.is_current_member" disabled="">当前登录账户</el-button>
									<el-button type="primary" v-else @click="swiuser(item)">切换当前账户</el-button>
								</div>
							</template>
							<template v-else>
								<p style="text-align: center">暂无更多账号信息</p>
							</template>
							<div slot="footer" class="dialog-footer">
								<el-button @click="dialogFormVisible = false">取 消</el-button>
								<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
							</div>
						</el-dialog>
                        </div>
                        <span @click="logout" class="ot">退出</span>
                    </div>
                    <router-link v-if="!logined" to="/register">免费注册</router-link>
                </div>
                <div class="top-right">
             
                    <router-link to="/index">首页</router-link>
                    <router-link to="/member/order_list">我的订单</router-link>
                    <router-link to="/member/footprint">我的足迹</router-link>
                    <router-link to="/member/collection">我的关注</router-link>

                    <router-link to="/cms/help">帮助中心</router-link>
                    <router-link to="/cms/notice">公告</router-link>
                    <!-- <el-dropdown v-if="qrcode">
                        <span class="el-dropdown-link">
                            小程序二维码
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <div class="mobile-qrcode">
                                    <el-image :src="$img(qrcode)"  style="width: 100px; height: 100px" >
                                        <div slot="error" class="image-slot">
                                            <img style="width: 100px; height: 100px" :src="require('@/assets/images/wx_qrcode.jpg')" />
                                        </div>
                                    </el-image>
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                    <div>
                        <el-button type="primary" plain style="padding: 5px 8px" size="small" @click="shoucang(siteInfo.site_name, '.url', 'https://b2b.scflk.com/')">保存到桌面</el-button>
                        <template v-if="allow_versionControl">
                            <el-button type="primary" plain style="padding: 5px 8px" size="small" @click.once="switch_versionControl">{{ versionControl_tip }}</el-button>
                        </template>
                        <template v-if="warehouse_host&&token">
                            <el-button type="primary" plain style="padding: 5px 8px" size="small" @click="openWarehouse">切换分仓</el-button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :custom-class="'dialogClass'" title="分仓列表" :visible.sync="warehouseState" width="30%">
            <div class="warehouse_content">
                <template v-for="item in warehouseList">
                    <div class="warehouse_item">
                        <div>
                            <p>分仓名称：{{ item.warehouse_name }}</p>
                            <p>分仓账户：{{ item.nickname }}</p>
                        </div>
                        <div>
                            <el-button @click="handWarehouse(item)" size="mini" type="primary" :disabled="warehouse_host==item.domain">
                                {{ warehouse_host==item.domain?'当前分仓':'切换分仓' }}
                            </el-button>
                        </div>
                    </div>
                </template>
                <template v-if="warehouseList.length===0">
                    <el-empty description="暂无分仓信息"></el-empty>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getToken,removeToken } from "@/utils/auth"
import { copyRight, shopServiceLists, friendlyLink, weQrcode, websiteInfo } from "@/api/website"
import { multiaccount } from '@/api/member/index';
import { getWarehouseList } from '@/api/member/warehouse';
import Config from "@/utils/config";
export default {
    props: {},
    data() {
        return {
            qrcode:'',
            dialogFormVisible:false,
            multiaccount: [],
            warehouseState:false,
            warehouseList:[],
            warehouse_host:'',
            versionControl_tip:'',
            allow_versionControl:false
        }
    },
    created() {
        this.$store.dispatch("site/qrCodes")
        this.$store.dispatch("member/member_detail")
        this.$store.dispatch("site/defaultFiles")
        this.$store.dispatch("site/addons")
        this.getqrcodeimg();
        this.getmultiaccount();
    },
    mounted() {
        this.warehouse_host = Config.warehouse_host;
        let versionControl = sessionStorage.getItem("versionControl");
        if(versionControl == "compartment"){
            this.versionControl_tip = "切换为默认版本";
        }else{
            this.versionControl_tip = "切换为分仓版本";
        }
        this.allow_versionControl = Config.allowVersion_switch;
    },
    watch: {},
    methods: {
        getmultiaccount() {
			multiaccount().then(res => {
				if (res.code == 0) {
					this.multiaccount = res.data.group_list

				}
			})
		},
        swiuser(item) {
			var data = {
				"member_id": item.member_id,
				"change": 1,
			}
			this.$store
				.dispatch("member/logintow", data)
				.then(res => {
					this.$message({
						message: "登录成功！",
						type: "success"
					})
					this.$router.go(0);
				})
		},
        jump(url) {
            this.$router.push({
                path: url
            })
        },
        shoucang(a, b, c) {
            let httpName = this.siteInfo.site_name;
            let httpUrl = window.location.href;
            this.downloadHtml(httpName,httpUrl);
        },
        downloadHtml(httpName,httpUrl) {
            // 定义要下载的 HTML 内容  
            let content = ``;
            content+=`<!DOCTYPE html>`;
            content+=`<html lang="zh">`;
            content+=`<head>`;
            content+=`<meta charset="UTF-8">`;
            content+=`<meta name="viewport" content="width=device-width, initial-scale=1.0">`;
            content+=`<title>${httpName}</title>`;
            content+=`<meta http-equiv="refresh" content="0; url=${httpUrl}" />`;
            content+=`</head>`;
            content+=`<body>`;
            content+=`</body>`;
            content+=`</html>`;
            const blob = new Blob([content], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = (httpName+'.html');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        saveToDesktop(fileName, data) {
            let explorer = navigator.userAgent.toLowerCase()
            if (explorer.indexOf("trident") > 0) {
                //IE 5+
                let wss = new ActiveXObject("WScript.Shell")
                let desktopUrl = wss.SpecialFolders("Desktop")
                let fso = new ActiveXObject("Scripting.FileSystemObject")
                let tf = fso.CreateTextFile(desktopUrl + "\\" + fileName, true)
                tf.Write(data)
                tf.Close()
            } else {
                //fireFox chrome
                let urlObj = window.URL || window.webkitURL || window
                let blob = new Blob([data])
                let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
                link.href = urlObj.createObjectURL(blob)
                link.download = fileName
                saveClick(link)
            }

            function saveClick(obj) {
                let e = document.createEvent("MouseEvents")
                e.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
                obj.dispatchEvent(e)
            }
        },
        logout() {
            this.$store.dispatch("member/logout")
        },
        getqrcodeimg() {
            weQrcode({})
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.qrcode = res.data
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message)
                })
        },
        adRightImageError(index) {
            this.adRightList[index].adv_image = this.defaultGoodsImage
        },
        openWarehouse(){
            if(sessionStorage.getItem("warehouse_host")){
                this.warehouse_host = sessionStorage.getItem("warehouse_host");
            }
            getWarehouseList().then(res =>{
                if(res.code==0){
                    this.warehouseState = true;
                    this.warehouseList = res.data;
                }else{
                    this.$message.error('获取分仓列表失败');
                }
            })
        },
        closeWarehouse(){
            this.warehouseState = false;
        },
        handWarehouse(info){
            this.$store.dispatch("member/login_warehouse",info).then((res)=>{
                if(res.code==0){
                    sessionStorage.setItem("warehouse_host",info.domain);
                    this.$message.success("切换分仓成功，稍后为您刷新界面");
                    this.closeWarehouse();
                    setTimeout(() => {
                        location.reload();
                    }, 1000);
                }
            })
        },
        switch_versionControl(){
            sessionStorage.clear();
            removeToken();
            this.$message.success("正在为您"+this.versionControl_tip);
            if(!this.warehouse_host){
                sessionStorage.setItem("versionControl","compartment");
            }
            setTimeout(()=>{
                location.reload();
            },1000)
        }
    },
    components: {},
    computed: {
        ...mapGetters(["token","wapQrcode", "member", "addonIsExit",'siteInfo']),
            // qrcode: function () {
            //     // return this.wapQrcode === "" ? "" : this.wapQrcode.path.h5.img
            //       return this.wapQrcode === "" ? "" : this.wapQrcode.path.h5.img
            // },
        logined: function () {
            return this.member !== undefined && this.member !== "" && JSON.stringify(this.member) !== '{}'
        }
    }
}
</script>
<style lang="scss">
.dialogClass{
    overflow: hidden;
    border-radius: 12px !important;
    .el-dialog__header{
        background-color: #32BC6F;
        span{
            color: white;
        }
        i{
            color: #32BC6F;
        }
        .el-dialog__headerbtn{
            top: 15px;
            background-color: #f5f5f5;
            border-radius: 50%;
            width: 30px;
            height: 30px;
        }
    }
    .el-dialog__body{
        padding: 12px;
    }
}
</style>
<style scoped lang="scss">
.dlistuser {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding-left: 10px;
    position: relative;
    height: 35px;
    line-height: 35px;
    margin-bottom: 10px;
    
    span {
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
    }
    
    .swinames {
        width: 270px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    
    button {
        position: absolute;
        right: 0;
        top: 0;
        line-height: 0;
        height: 35px;
    }
}
.header-top {
    width: 100%;
    height: 31px;
    font-size: 12px;
    background-color: #f5f5f5;

    .el-dropdown {
        font-size: $ns-font-size-sm;
    }

    .top-content {
        width: $width;
        height: 100%;
        margin: 0 auto;
        justify-content: space-between;
        align-items: center;
        display: flex;
        .top-right {
            height: 100%;
            font-size: $ns-font-size-sm;
            color: $ns-text-color-black;
            a {
                line-height: 31px;
                padding: 0 10px;
                &:hover {
                    color: $base-color;
                }
            }

            div {
                float: left;
                height: 100%;
               
                cursor: pointer;
                line-height: 31px;
                padding: 0 5px;

                & .member-info {
                    display: flex;
                    align-items: center;
                    span:first-child {
                        margin-right: 10px;
                    }
                  
                }

                span:hover {
                    color: $base-color;
                }

                &.el-dropdown:hover {
                    background-color: #fff;
                }
            }
        }
    }
}

.userSwitch{
    display: flex;
    align-items: center;
    gap: 12px;
    >div{
        border-left: 1px solid #ccc;
        padding-left: 12px;
    }
    span{
        color: #32BC6F;
        cursor: pointer;
    }
}

.mobile-qrcode {
    padding: 10px 0;
}

.router-link-active {
    color: $base-color;
}
.ot:hover{
        color: $base-color;
}
// .router-link-exact-active{
//  color: $base-color;
// }
.warehouse_content{
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    .warehouse_item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #f5f5f5;
        padding: 12px;
        box-sizing: border-box;
        border-radius: 6px;
        // box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
        >div:nth-child(1){
            display: flex;
            flex-direction: column;
            >p:nth-child(1){
                color: #333;
                font-weight: bold;
            }
            >p:nth-child(2){
                color: #666;
            }
        }
    }
}
</style>
